<!-- prettier-ignore -->
<span *ngFor="let part of parts" [class.highlight]="part.highlight" [style.color]="part.highlight ? color : null">{{ part.text }}</span>
